import keys from 'lodash/keys'
import { flattenObject } from '../../flatten-object'
import some from 'lodash/some'
import isArray from 'lodash/isArray'

/**
 * A function that checks if the specified object has the specified keys, using the regular expression
 */
export function hasKeys(object: any, paths: RegExp[] | RegExp, allowPartialMatch = false): boolean {
  //we need to flatten first the object, so we can get all the keys
  const flattened = flattenObject(object, { array: true })

  //we need to find the keys that match the regular expressions
  const allKeys = keys(flattened)

  const regexArray = isArray(paths) ? paths : [paths]
  return some(allKeys, (key) =>
    some(regexArray, (path) => {
      if (allowPartialMatch) {
        return path.test(key)
      } else {
        // Otherwise, use anchors to ensure exact matches
        const exactRegex = new RegExp(`^${path.source}$`)
        return exactRegex.test(key)
      }
    })
  )
}
